import type { components } from "../generated/api-types.js";
import {
  type BodyTransformOptions,
  computeBodyMdStats,
  processBodyMd,
} from "./body-transformer.js";

export type PostTransformOptions = BodyTransformOptions;

export function transformPost(
  post: components["schemas"]["Post"],
  options: PostTransformOptions = {},
) {
  const bodyMd = processBodyMd(post.body_md, options);
  // Omit stats alongside the body so mutation responses (create/update/rollback,
  // which pass omitBody) don't return stats for a body they don't include.
  // truncate still keeps stats so they reflect the full, pre-truncation body.
  const bodyMdStats = options.omitBody
    ? undefined
    : computeBodyMdStats(post.body_md);

  return {
    url: post.url,
    revision_number: post.revision_number,
    wip: post.wip ? "WIP" : ("Shipped" as const),
    kind: post.kind,
    category_and_title_and_tags: post.full_name,
    ...(bodyMd !== undefined && { body_md: bodyMd }),
    ...(bodyMdStats !== undefined && { body_md_stats: bodyMdStats }),
    created_at: post.created_at,
    updated_at: post.updated_at,
    created_by: post.created_by,
    updated_by: post.updated_by,
    stats: {
      tasks_count: post.tasks_count,
      done_tasks_count: post.done_tasks_count,
      comments_count: post.comments_count,
      stargazers_count: post.stargazers_count,
      watchers_count: post.watchers_count,
    },
    ...(post.backlinks_count !== undefined && {
      backlinks_count: post.backlinks_count,
    }),
  };
}

export type TransformedPost = ReturnType<typeof transformPost>;
